<template>
  <div class="crp-panel">
    <div v-if="loaded">
      <validation-observer ref="refFormObserver">
        <div class="crp-header">
          <div class="crp-header-icon">
            <i class="fas fa-file-contract"></i>
          </div>
          <div>
            <div class="crp-header-title">{{ msg('Generate contract') }}</div>
            <div class="crp-header-sub">{{ msg('Fill in the contract details below') }}</div>
          </div>
        </div>
        <b-row class="crp-form-grid">
          <b-col cols="12" md="6" lg="4">
            <div class="crp-field">
              <label class="crp-label">{{ msg('Client Id') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Client')" rules="required">
                <client-picker v-model="contract.clientId"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <div class="crp-field">
              <label class="crp-label">{{ msg('Property Id') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Property')" rules="required">
                <real-estate-picker v-model="contract.propertyId"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="4">
            <div class="crp-field">
              <label class="crp-label">{{ msg('Usage') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Usage')" rules="required">
                <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="contract.use" :options="[{value:'PRIVATE',label:msg('Private use')},{value:'COMMERCIAL',label:msg('Commercial use')}]" label="label" :reduce="(s) => s.value" class="w-100 crp-select" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="crp-field">
              <label class="crp-label">{{ msg('Language') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Language')" rules="required">
                <v-select :dir="isRTL ? 'rtl' : 'ltr'" :clearable="false" v-model="contract.language" :options="[{id:'EN',name:'English'},{id:'ES',name:'Spanish'},{id:'FR',name:'French'},{id:'DE',name:'German'},{id:'IT',name:'Italian'},{id:'PT',name:'Portuguese'},{id:'RU',name:'Russian'},{id:'CN',name:'Chinese'},{id:'JP',name:'Japanese'}]" class="w-100 crp-select" label="name" :reduce="(b) => b.id" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </div>
    <div v-else-if="this.error != null">
      <div class="crp-error">
        <i class="fas fa-exclamation-triangle mr-75"></i>
        <strong>{{ error }}</strong>
      </div>
    </div>
    <div v-else class="crp-loading">
      <b-spinner variant="primary" />
      <span class="ml-75">{{ msg('loading') }}</span>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ClientPicker from "@/components/components/picker/clientPicker";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker";

export default {
  name: 'contractRentPanel',
  components: {RealEstatePicker, ClientPicker},
  data() {
    return {
      loaded: false,
      error: null,
      contractId: 0,
      contract: {
        name: '',
        type: null,
      },
      listeners: {
        submit: () => {
        }
      }
    }
  },
  watch: {
    id: function () {
      this.onLoad()
      this.error = null
    }
  },
  computed: {
    ...mapGetters('realEstate', ['getAllTypes']),
  },
  created() {
    this.onLoad()
    this.$root.$on('crm::submitContract', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitContract', this.listeners.submit)
  },
  methods: {
    ...mapActions('realEstateContracts', {
      _createContract: 'createContract',
    }),
    onLoad() {
      this.loaded = true
    },
    createContract() {
      let $this = this
      this.$refs['refFormObserver'].validate().then(valid => {
        if (!valid)
          return;
        $this._createContract(this.contract)
            .then(
                (id) => {
                  $this.contractId = id
                  $this.$emit('submitted', {
                    status: true,
                    server: id,
                    id
                  })
                },
                (a) => $this.$emit('submitted', {
                  status: false,
                  server: a
                })
            )
            .finally(() => {
              if ($this.contractId != null && $this.contractId !== 0)
                this.$router.push(`/real_estate/contracts/rent/${$this.contractId}`);
            })
      })
    },
    validate(field) {
      return this.$v.contract[field] != null && this.$v.contract[field].$error === true
    },
    submit() {
      return this.createContract()
    }
  },
}
</script>

<style scoped>
.crp-panel { padding: 8px; }
.crp-header { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
.crp-header-icon { width: 44px; height: 44px; border-radius: 14px; display: flex; align-items: center; justify-content: center; background: rgba(115,103,240,.12); color: #7367f0; font-size: 18px; flex-shrink: 0; }
.crp-header-title { font-weight: 900; font-size: 16px; }
.crp-header-sub { font-size: 12px; opacity: .6; }
.crp-form-grid { row-gap: 8px; }
.crp-field { margin-bottom: 8px; }
.crp-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; opacity: .65; margin-bottom: 4px; display: block; }
.crp-select :deep(.vs__dropdown-toggle) { border-radius: 10px; }
.crp-error { padding: 16px; border-radius: 14px; background: rgba(234,84,85,.08); border: 1px solid rgba(234,84,85,.2); color: #ea5455; }
.crp-loading { display: flex; align-items: center; justify-content: center; min-height: 200px; opacity: .7; }
</style>
